<template>
  <div v-if="!showTenant" data-testid="tenantmanagement-container" class="h-full m-5 mr-10 overflow-visible overflow-y-scroll pb-36" ref="tenantContainer">
    <div>
      <table data-testid="tenantmanagement-tenant-table" class="w-full min-w-full divide-y divide-gray-200">
        <thead class="hidden w-full bg-gray-100 md:table-header-group ">
          <tr>
            <th v-if="isSuperAdmin" scope="col" class="px-6 py-4 text-xs font-medium tracking-wider text-left text-gray-500 uppercase">
              {{ $t("userManagement.tenantTable.slug") }}
            </th>

            <th scope="col" class="flex-1 w-full px-6 py-4 text-xs font-medium tracking-wider text-left text-gray-500 uppercase">
              {{ $t("userManagement.tenantTable.name") }}
            </th>

          </tr>
        </thead>
        <tbody data-testid="tenantmanagement-tenant-table-body" class="h-full bg-white divide-y-2 divide-gray-400 md:divide-y md:divide-gray-200 md:table-row-group">
          <tr v-for="tenant in tenants" :key="tenant.id" :data-testid="`tenantmanagement-tenant-row-${tenant.slug}`" class="flex flex-wrap cursor-pointer hover:bg-slate-100 md:table-row even:bg-gray-50 odd:bg-white md:even:bg-white" @click="selectTenant(tenant)">
            <th v-if="isSuperAdmin" scope="col" class="flex flex-1 min-w-full gap-5 px-6 py-4 text-xs font-medium tracking-wider text-left text-gray-500 uppercase md:whitespace-nowrap md:table-cell">
              <span class="font-thin md:hidden"> {{ $t("userManagement.tenantTable.slug") }}:</span>
              {{ tenant.slug }}
            </th>

            <td class="flex flex-1 min-w-full gap-5 px-6 py-3 md:whitespace-nowrap md:table-cell">
              <span class="font-thin md:hidden"> {{ $t("userManagement.tenantTable.name") }}:</span>
              {{ tenant.name }}
            </td>
          </tr>

          <template v-if="loading">
            <tr v-for="row in 5" :key="row" data-testid="tenantmanagement-tenant-row-loading" class="animate-pulse">
              <td class="px-1 py-2">
                <div class="w-full h-4 bg-gray-300 rounded"></div>
              </td>
              <td class="px-1 py-2">
                <div class="w-full h-4 bg-gray-300 rounded"></div>
              </td>

            </tr>
          </template>

        </tbody>
      </table>

    </div>

    <div class="absolute m-auto bottom-4 right-4">
      <div data-testid="tenantmanagement-create-button" class="w-10 h-10 m-auto text-white bg-blue-500 rounded-full shadow-lg cursor-pointer hover:bg-blue-700 active:scale-105 active:shadow-lg" @click="showTenant = true; isCreate = true;">
        <div class="flex justify-center h-full m-auto ">
          <PlusIcon class="relative h-5 m-auto"></PlusIcon>
        </div>
      </div>
    </div>
  </div>

  <CreateUpdateTenant v-if="showTenant" :isCreate="isCreate" :tenant="selectedTenant" @cancel="showTenant = false, selectedTenant = {}" @refreshData="refreshData" />

</template>
<script>
import { computed, ref } from 'vue';
import { useStore } from 'vuex';
import { useInfiniteScroll } from '@vueuse/core';
import { PlusIcon } from "@heroicons/vue/outline";
import CreateUpdateTenant from './CreateUpdateTenant.vue';

export default {
  name: "TenantManagement",
  components: {
    PlusIcon,
    CreateUpdateTenant,
  },

  setup() {
    const store = useStore();
    const tenants = computed(() => store.state.tenants);
    const loading = computed(() => store.state.loading)

    const showTenant = ref(false);
    const isCreate = ref(false);
    const selectedTenant = ref({})
    const tenantContainer = ref(null);

    const isSuperAdmin = computed(() => {
      return store.getters["auth/isSuperAdmin"];
    });

    useInfiniteScroll(tenantContainer,
      async () => {
        await store.dispatch("loadTenants", false);
      },
      {
        distance: 10,
        canLoadMore: () => {
          return store.state.hasNextPage || !store.state.tenants
        },
      })


    const selectTenant = (tenant) => {
      selectedTenant.value = tenant;
      showTenant.value = true;
      isCreate.value = false;
    };

    const refreshData = async () => {
      await Promise.all([
        store.dispatch("loadTenants", true),
        store.dispatch("users/getUsers", true),
        store.dispatch("loadAllTenants", true)
      ])
      selectedTenant.value = {};
    }

    return {
      tenants,
      isSuperAdmin,
      showTenant,
      isCreate,
      selectedTenant,
      selectTenant,
      refreshData,
      tenantContainer,
      loading,
    }
  },

};
</script>
